import { useState, useEffect } from "react";
import { toast } from "react-toastify";
import { ApiUrl } from "../ApiUrl";

const useGetViewsData = (viewType) => {
  const [data, setData] = useState([]);
  const token = localStorage.getItem("token");

  const fetchUser = async () => {
    try {
      const res = await fetch(ApiUrl + "/api/user/get_views", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
          type: viewType,
        }),
      });
      const data = await res.json();
      if (data.status === "success") {
        const parsedUserData = JSON.parse(JSON.stringify(data.userView));

        // Parse columns for each user view
        parsedUserData.user_views = parsedUserData.user_views.map((view) => ({
          ...view,
          columns: JSON.parse(view.columns),
        }));
        setData(parsedUserData);
      }
    } catch (error) {
      console.log("🚀 ~ fetchUser ~ error:", error);
    }
  };

  useEffect(() => {
    if (token) {
      fetchUser();
    }
  }, []);

  return data;
};

export default useGetViewsData;
